import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  tr: {
    app_name: "KiraTakip",
    tagline: "Kira ve gider yönetimi",
    login: "Giriş Yap", register: "Kayıt Ol", logout: "Çıkış",
    email: "E-posta", password: "Şifre", name: "Ad Soyad",
    no_account: "Hesabınız yok mu?", have_account: "Zaten üye misiniz?",
    dashboard: "Kontrol Paneli", properties: "Evler", tenants: "Kiracılar",
    payments: "Ödemeler", expenses: "Giderler", calendar: "Takvim", reports: "Raporlar",
    expected_month: "Bu Ay Beklenen Kira", collected: "Tahsil Edilen",
    overdue: "Geciken Kiralar", upcoming7: "Önümüzdeki 7 Gün",
    total_income: "Toplam Gelir (Yıl)", total_expense: "Toplam Gider (Yıl)",
    net: "Net", tenants_count: "Aktif Kiracı", properties_count: "Ev Sayısı",
    contracts_ending: "Bitmek Üzere Sözleşmeler",
    insurance_expiring: "Sigorta Bitmek Üzere",
    add: "Ekle", edit: "Düzenle", delete: "Sil", cancel: "İptal", save: "Kaydet",
    confirm_delete: "Silmek istediğinizden emin misiniz?",
    property_name: "Ev Adı", address: "Adres", rooms: "Oda Sayısı", notes: "Notlar",
    owner_name: "Ev Sahibi", owner_phone: "Ev Sahibi Tel", owner_email: "Ev Sahibi E-posta",
    full_name: "Ad Soyad", phone: "Telefon", id_number: "Kimlik/Pasaport",
    lease_start: "Sözleşme Başlangıç", lease_end: "Sözleşme Bitiş",
    deposit: "Depozito", deposit_currency: "Depozito Döviz",
    deposit_rate: "Alındığı Tarihteki Kur (₺)", deposit_date: "Depozito Tarihi",
    monthly_rent: "Aylık Kira", rent_currency: "Kira Döviz",
    payment_day: "Ödeme Günü",
    bank_name: "Banka", bank_iban: "IBAN", bank_holder: "Hesap Sahibi",
    active: "Aktif", inactive: "Pasif", select_property: "Ev Seçin",
    all_properties: "Tüm Evler", room: "Oda",
    category: "Kategori", amount: "Tutar", date: "Tarih", vendor: "Firma",
    currency: "Döviz", rate: "Kur (TRY)",
    insurance_start: "Sigorta Başlangıç", insurance_end: "Sigorta Bitiş",
    electricity: "Elektrik", water: "Su", gas: "Doğalgaz", internet: "İnternet",
    hoa: "Aidat", mortgage: "Mortgage", insurance: "Sigorta", repairs: "Tamirat", other: "Diğer",
    mark_paid: "Ödendi İşaretle", unmark: "Kaldır", send_receipt: "Makbuz E-postası Gönder",
    status: "Durum", paid: "Ödendi", pending: "Bekliyor", overdue_s: "Gecikti",
    due_date: "Vade", tenant: "Kiracı", month: "Ay", year: "Yıl",
    monthly_pl: "Aylık Kar-Zarar", yearly_pl: "Yıllık Rapor",
    by_property: "Ev Bazında", by_owner: "Ev Sahibi Bazında",
    detailed_report: "Detaylı Rapor",
    export_csv: "CSV İndir", export_pdf: "PDF İndir",
    export_payments: "Ödemeleri CSV İndir",
    export_expenses: "Giderleri CSV İndir",
    export_detailed_csv: "Detaylı CSV İndir",
    export_detailed_pdf: "Detaylı PDF İndir",
    send_reminder: "Hatırlatma Gönder", email_sent: "E-posta gönderildi",
    login_needed: "Devam etmek için giriş yapın",
    no_data: "Kayıt yok", welcome: "Hoş geldiniz",
    days_left: "gün kaldı", income: "Gelir", expense: "Gider",
    contract_ends: "Sözleşme Bitiyor",
    months: ["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],
    property: "Ev",
    notify_due: "Ödeme günü hatırlatması",
    notify_overdue: "Gecikme uyarısı",
    notify_contract: "Sözleşme bitiş uyarısı",
    renew: "Sözleşme Yenile",
    new_lease_start: "Yeni Başlangıç", new_lease_end: "Yeni Bitiş",
    new_rent: "Yeni Kira Bedeli",
    lease_history: "Sözleşme Geçmişi",
    auto_receipt_hint: "Makbuz e-postası otomatik gönderilecek",
    all_currencies: "Tüm Dövizler",
    receipt_will_send: "Ödeme sonrası makbuz e-postası gönderilecek",
    from_date: "Başlangıç", to_date: "Bitiş",
    all_statuses: "Tümü",
    this_month: "Bu Ay", this_year: "Bu Yıl",
    expected_range: "Beklenen (Aralık)",
    fetch_rate: "Bugünkü Kur",
    fetch_rate_ok: "Güncel kurlar alındı",
    fetch_rate_err: "Kur alınamadı",
    insurance_overdue: "SÜRESI GEÇTI",
    days_ago: "gün önce",
    insurance_info: "Sigorta Bilgisi",
    export_owner_csv: "Ev Sahibi CSV",
    export_owner_pdf: "Ev Sahibi PDF",
    export_property_csv: "Ev Bazlı CSV",
    export_property_pdf: "Ev Bazlı PDF",
    view_currency: "Görüntüle",
    view_currency_hint: "Tüm TRY toplamları seçilen döviz cinsine bugünkü kurdan çevrilir",
    documents: "Belgeler",
    upload: "Yükle",
    download: "İndir",
    kind_contract: "Sözleşme", kind_id: "Kimlik", kind_other: "Diğer",
    run_overdue: "Gecikme E-postalarını Gönder",
    overdue_ran: "Gecikme kontrolü çalıştırıldı",
    no_documents: "Belge yok",
  },
  en: {
    app_name: "KiraTakip",
    tagline: "Rent & expense management",
    login: "Log In", register: "Sign Up", logout: "Log Out",
    email: "Email", password: "Password", name: "Full Name",
    no_account: "No account?", have_account: "Already a member?",
    dashboard: "Dashboard", properties: "Properties", tenants: "Tenants",
    payments: "Payments", expenses: "Expenses", calendar: "Calendar", reports: "Reports",
    expected_month: "Expected This Month", collected: "Collected",
    overdue: "Overdue", upcoming7: "Next 7 Days",
    total_income: "Total Income (YTD)", total_expense: "Total Expense (YTD)",
    net: "Net", tenants_count: "Active Tenants", properties_count: "Properties",
    contracts_ending: "Contracts Ending Soon",
    insurance_expiring: "Insurance Expiring",
    add: "Add", edit: "Edit", delete: "Delete", cancel: "Cancel", save: "Save",
    confirm_delete: "Are you sure to delete?",
    property_name: "Property Name", address: "Address", rooms: "Rooms", notes: "Notes",
    owner_name: "Property Owner", owner_phone: "Owner Phone", owner_email: "Owner Email",
    full_name: "Full Name", phone: "Phone", id_number: "ID/Passport",
    lease_start: "Lease Start", lease_end: "Lease End",
    deposit: "Deposit", deposit_currency: "Deposit Currency",
    deposit_rate: "FX Rate at Receipt (TRY)", deposit_date: "Deposit Date",
    monthly_rent: "Monthly Rent", rent_currency: "Rent Currency",
    payment_day: "Payment Day",
    bank_name: "Bank", bank_iban: "IBAN", bank_holder: "Account Holder",
    active: "Active", inactive: "Inactive", select_property: "Select Property",
    all_properties: "All Properties", room: "Room",
    category: "Category", amount: "Amount", date: "Date", vendor: "Vendor",
    currency: "Currency", rate: "Rate (TRY)",
    insurance_start: "Insurance Start", insurance_end: "Insurance End",
    electricity: "Electricity", water: "Water", gas: "Gas", internet: "Internet",
    hoa: "HOA", mortgage: "Mortgage", insurance: "Insurance", repairs: "Repairs", other: "Other",
    mark_paid: "Mark Paid", unmark: "Unmark", send_receipt: "Send Receipt Email",
    status: "Status", paid: "Paid", pending: "Pending", overdue_s: "Overdue",
    due_date: "Due", tenant: "Tenant", month: "Month", year: "Year",
    monthly_pl: "Monthly P&L", yearly_pl: "Yearly Report",
    by_property: "By Property", by_owner: "By Owner",
    detailed_report: "Detailed Report",
    export_csv: "Export CSV", export_pdf: "Export PDF",
    export_payments: "Export Payments CSV",
    export_expenses: "Export Expenses CSV",
    export_detailed_csv: "Detailed CSV",
    export_detailed_pdf: "Detailed PDF",
    send_reminder: "Send Reminder", email_sent: "Email sent",
    login_needed: "Please log in to continue",
    no_data: "No records", welcome: "Welcome",
    days_left: "days left", income: "Income", expense: "Expense",
    contract_ends: "Contract Ending",
    months: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    property: "Property",
    notify_due: "Payment due reminder",
    notify_overdue: "Overdue warning",
    notify_contract: "Contract ending notice",
    renew: "Renew Contract",
    new_lease_start: "New Start", new_lease_end: "New End",
    new_rent: "New Rent",
    lease_history: "Lease History",
    auto_receipt_hint: "Receipt email will be sent automatically",
    all_currencies: "All Currencies",
    receipt_will_send: "A receipt email will be sent after payment",
    from_date: "From", to_date: "To",
    all_statuses: "All",
    this_month: "This Month", this_year: "This Year",
    expected_range: "Expected (Range)",
    fetch_rate: "Today's Rate",
    fetch_rate_ok: "Live rates fetched",
    fetch_rate_err: "Failed to fetch rate",
    insurance_overdue: "OVERDUE",
    days_ago: "days ago",
    insurance_info: "Insurance",
    export_owner_csv: "Owner CSV",
    export_owner_pdf: "Owner PDF",
    export_property_csv: "Property CSV",
    export_property_pdf: "Property PDF",
    view_currency: "View in",
    view_currency_hint: "All TRY totals are converted to the selected currency at today's rate",
    documents: "Documents",
    upload: "Upload",
    download: "Download",
    kind_contract: "Contract", kind_id: "ID", kind_other: "Other",
    run_overdue: "Send Overdue Emails",
    overdue_ran: "Overdue check ran",
    no_documents: "No documents",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "tr");
  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);
  const t = (k) => (dict[lang] && dict[lang][k]) ?? k;
  return (
    <I18nContext.Provider value={{ lang, setLang, t, dict: dict[lang] }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
